import React, { useState } from 'react'
import Image from 'next/image'
import dynamic from 'next/dynamic'

const ChallengeOptions = dynamic(() => import('./sub-menu'))
const ContentExpander = dynamic(() => import('./content-expander'))
import { addParagraphs } from '../src/formatter'

const ChallengeImage = ({challenge}) => {
  const [error, setError] = useState(false)
  return error ? <></> : <Image
    width={0} height={0}
    alt={challenge.challengeName}
    src={`${process.env.CDN}/${challenge.logo}`}
    sizes="(min-width: 768px) 300px, 400px"
    className='object-contain rounded-md w-auto max-h-[250px] mx-auto'
    onError={() => setError(true)}
  />
}

const WsoVideo = ({ challenge }) => {
  let autoPlay = true
  if (window?.isNativeApp) autoPlay = false
  
  let videoFile = 'https://cdn.challengehound.com/wso-greaterthan.mp4'
  
  const spanishChallenges = [
    '0bff6bf0-7d02-11ef-9948-b9c9372c8e2f', // mex
    '8e28bce0-704a-11ef-acaa-6ff0f879c203', // guat
    'bc77fb40-7f47-11ef-b315-714c3bbf0e2c', // hondur
    'f0a97e20-7f47-11ef-b315-714c3bbf0e2c', // costa rica
    '1d4f2f30-7d02-11ef-9948-b9c9372c8e2f', // arg
    '050c9be0-7f48-11ef-b315-714c3bbf0e2c', // chile
    '77acde50-800e-11ef-bee0-35499e842ddd', // peru
    'c40eea10-7049-11ef-84fb-11197161944f', // colombia
    '6c144890-8765-11ef-a87c-43bf2079e566', // paraguay
    '1d848d7e-66a5-41aa-a5df-f0e35c9575c3', // Salvador
    '81721c8e-14f3-4c7a-978a-6fef852fdc9d', // Bolivia
    '77429179-ac3d-43eb-9bc6-e0ff135c78af', // Panama
  ]

  if (spanishChallenges.includes(challenge.id)) {
    videoFile = 'https://cdn.challengehound.com/wso-greaterthan-es.mp4'
  }
  return <video controls autoPlay={autoPlay} playsInline={true} muted className='m2 min-h-[230px] w-auto' >
    <source src={videoFile} type="video/mp4" />
    <ChallengeImage challenge={challenge} />
  </video>
}

const ChallengeHeader = ({ challenge, desc, page }) => {
  return (
    <div className='mb-8'>
      <div className='md:flex justify-center items-center mb-12'>
        {challenge.group.organizationId === 'dce31a80-3de9-11ef-8439-e17b870492eb' && // wso org
          <div className='md:hidden border-1 border-gray-300 rounded-md w-full min-h-[230px] mb-4 p-1'>
            <WsoVideo challenge={challenge} />
          </div>
        }
        {(challenge.group.organizationId !== 'dce31a80-3de9-11ef-8439-e17b870492eb' && challenge.logo) && <div className='md:hidden mb-4 w-full max-h-[250px] md:max-h-[300px]'>
          <ChallengeImage challenge={challenge} />
        </div>}
        <div className='grow'>
          <div className='text-2xl md:text-4xl font-retro text-chHeader font-bold leading-tight mt-2 mb-2'>{challenge.challengeName}</div>
            
          {desc && <ContentExpander content={addParagraphs(challenge.challengeDesc)} />}
        </div>
        {challenge.group.organizationId === 'dce31a80-3de9-11ef-8439-e17b870492eb' && // wso org
          <div className='hidden md:block ml-8 relative border-1 border-gray-300 rounded-md w-full md:min-w-[425px] min-h-[230px] p-1 max-w-[450px]'>
            <WsoVideo challenge={challenge} />
          </div>
        }
        {(challenge.group.organizationId !== 'dce31a80-3de9-11ef-8439-e17b870492eb' && challenge.logo) && <div className={`hidden md:block ml-8 relative min-w-[250px]`}>
          <ChallengeImage challenge={challenge} />
        </div>}
      </div>
      <ChallengeOptions page={page} challenge={challenge} />
    </div>
  );
}

export default ChallengeHeader
